import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class GerarPedidoService {

  constructor(private http: HttpService) { }

  enterpriseListByCnpj(data: any, successHandle: Function, errorHandle: Function) {
    
    this.http.doGet('/enterprise/enterpriseListByCnpj', data, successHandle, errorHandle);

  }

  saleRegister(data: any, successHandle:Function, errorHandle:Function) {
    return this.http.doPost('/enterprise/onlineSaleRegister', data, successHandle, errorHandle);
  }

}

